import { useCallback } from 'react';
import { Loading } from '@/components/loading';
import { ConnectedApplications } from '@/components/connected-applications';
import { useNow } from '@/hooks/use-now';
import {
  useConnectedApplicationsQuery,
  useRevokeApplicationMutation,
} from '@/api/oauth';

const SettingsConnectedApplications = () => {
  const now = useNow();
  const { data, isLoading } = useConnectedApplicationsQuery();
  const [revokeApplication] = useRevokeApplicationMutation();

  const onRevoke = useCallback(
    (clientId: string) => {
      revokeApplication(clientId);
    },
    [revokeApplication],
  );

  if (isLoading || !data) {
    return <Loading />;
  }

  return (
    <ConnectedApplications
      applications={data.connected_applications}
      now={now}
      onRevoke={onRevoke}
    />
  );
};

export { SettingsConnectedApplications };
